import { render } from "./formula-detail.vue?vue&type=template&id=5982ccc2&scoped=true&ts=true"
import script from "./formula-detail.vue?vue&type=script&lang=ts"
export * from "./formula-detail.vue?vue&type=script&lang=ts"

import "./formula-detail.vue?vue&type=style&index=0&id=5982ccc2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5982ccc2"]])

export default __exports__